import type { TypographyVariantsOptions } from '@mui/material/styles';

import { themeConfig } from './theme-config';
import { pxToRem, setFont } from './utils';

export type FontStyleExtend = {
  fontWeightSemiBold: string | number;
  fontSecondaryFamily: string;
};

const primaryFont = setFont(themeConfig.fontFamily.primary);
const secondaryFont = setFont(themeConfig.fontFamily.secondary);

/**
 * A hierarquia do guia: títulos em Space Grotesk (600/700, entrelinha 1.1–1.2), corpo em
 * Manrope (400/500, entrelinha 1.5–1.7), assinatura em Manrope 700 versalete.
 */
export const typography: TypographyVariantsOptions = {
  fontFamily: primaryFont,
  fontSecondaryFamily: secondaryFont,
  fontWeightLight: '300',
  fontWeightRegular: '400',
  fontWeightMedium: '500',
  fontWeightSemiBold: '600',
  fontWeightBold: '700',
  h1: {
    fontFamily: secondaryFont,
    fontWeight: 700,
    lineHeight: 1.12,
    fontSize: pxToRem(40),
    letterSpacing: '-0.02em',
  },
  h2: {
    fontFamily: secondaryFont,
    fontWeight: 700,
    lineHeight: 1.16,
    fontSize: pxToRem(32),
    letterSpacing: '-0.015em',
  },
  h3: { fontFamily: secondaryFont, fontWeight: 700, lineHeight: 1.2, fontSize: pxToRem(24) },
  h4: { fontFamily: secondaryFont, fontWeight: 700, lineHeight: 1.25, fontSize: pxToRem(20) },
  h5: { fontFamily: secondaryFont, fontWeight: 600, lineHeight: 1.3, fontSize: pxToRem(18) },
  h6: { fontFamily: secondaryFont, fontWeight: 600, lineHeight: 1.35, fontSize: pxToRem(17) },
  subtitle1: { fontWeight: 600, lineHeight: 1.5, fontSize: pxToRem(16) },
  subtitle2: { fontWeight: 600, lineHeight: 22 / 14, fontSize: pxToRem(14) },
  body1: { lineHeight: 1.6, fontSize: pxToRem(16) },
  body2: { lineHeight: 1.6, fontSize: pxToRem(14) },
  caption: { lineHeight: 1.5, fontSize: pxToRem(12) },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
  },
  button: { fontWeight: 700, lineHeight: 24 / 14, fontSize: pxToRem(14), textTransform: 'unset' },
};
